/**
 * Clipping Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.8.25
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ManagementRecordingScheduleResponse {
    id: string;
    mediumId?: string;
    startTime?: string;
    durationMinutes?: number;
    daysOfWeek?: Array<ManagementRecordingScheduleResponse.DaysOfWeekEnum>;
    enabled?: boolean;
}
export namespace ManagementRecordingScheduleResponse {
    export type DaysOfWeekEnum = 'MONDAY' | 'TUESDAY' | 'WEDNESDAY' | 'THURSDAY' | 'FRIDAY' | 'SATURDAY' | 'SUNDAY';
    export const DaysOfWeekEnum = {
        MONDAY: 'MONDAY' as DaysOfWeekEnum,
        TUESDAY: 'TUESDAY' as DaysOfWeekEnum,
        WEDNESDAY: 'WEDNESDAY' as DaysOfWeekEnum,
        THURSDAY: 'THURSDAY' as DaysOfWeekEnum,
        FRIDAY: 'FRIDAY' as DaysOfWeekEnum,
        SATURDAY: 'SATURDAY' as DaysOfWeekEnum,
        SUNDAY: 'SUNDAY' as DaysOfWeekEnum
    };
}
